import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'

export const Section = styled.div`
  min-width: 0; /* Allow this flex child to collapse and show truncated content in nested elements */
  display: flex;
  align-items: center;
`

export const Close = styled.div`
  margin-left: 12px;
`

export const Name = styled.div`
  margin-left: 12px;
  min-width: 0; /* Allow this flex child to collapse and show truncated content in nested elements */
`

export const Item = styled.div`
  margin-right: 16px;
  height: 32px;

  ${breakpoint('xs')`
    display: none;
  `}
`

export const ItemDesktop = styled(Item)`
  display: none;

  ${breakpoint('xs')`
    display: block;
  `}
`
